<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <h4 class="col-12">Meta informacje</h4>
      <div class="col-12">
        <b-form-group id="input-group-1" label="Nazwa wzoru:" label-for="input-1" description="">
          <b-form-input
            id="input-1"
            v-model="document.name"
            type="text"
            required
            placeholder="Wpisz nazwę"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-12">
        <h5>Lista dostęppnych znaczników:</h5>
        <hr />
        <h6>Dane kontrahenta</h6>
        <ul>
          <li>Imię: <b>$name</b></li>
          <li>Nazwisko: <b>$lastname</b></li>
        </ul>
      </div>
      <div class="col-12">
        <b-button @click="exit" variant="outline" class="btn-outline-danger mr-2"
          >Przerwij tworzenie dokumentu</b-button
        >
        <b-button @click="create" variant="success">Utwórz wzór dokumentu</b-button>
      </div>
    </div>
    <editor id="editor" :api-key="apiKey" :init="init" v-model="document.value"></editor>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
// import '@/assets/js/tinymce/pl'

export default {
  name: 'DocumentCreator',
  data() {
    return {
      apiKey: 'jl9he2vlankzw1f6ry2xli9tbiqbdremue683lxb17zydtvd',
      init: {
        language: 'pl',
        language_url: '/js/tinymce/pl.js',
        fullpage_default_font_family: 'dejavusans',
        fullpage_default_langcode: 'pl-PL',
        content_css: ['https://cdn.rawgit.com/milligram/milligram/master/dist/milligram.min.css'],
        plugins: [
          'print',
          'autoresize',
          'autolink',
          'autosave',
          // 'fullscreen',
          'help',
          'insertdatetime',
          'link',
          'lists',
          'nonbreaking',
          'pagebreak',
          'paste',
          'save',
          'spellchecker',
          'table',
          'image'
        ],
        toolbar: [
          'save',
          'print',
          'undo redo | styleselect | bold italic | link image',
          'alignleft aligncenter alignright',
          'image',
          'insertdatetime',
          'link',
          'numlist',
          'bullist',
          'nonbreaking',
          'paste',
          'pagebreak',
          'spellchecker',
          'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
          'help'
          // 'fullscreen'
        ],
        save_enablewhendirty: true,
        save_oncancelcallback() {
          console.log('Save canceled')
        },
        save_onsavecallback(e) {
          console.log(e)
        },
        images_upload_url: 'index.php',
        images_upload_handler(blobInfo, success, failure) {
          setTimeout(() => {
            /* no matter what you upload, we will turn it into TinyMCE logo :) */
            success('http://moxiecode.cachefly.net/tinymce/v9/images/logo.png')
          }, 2000)
        }
      },
      document: {
        name: '',
        value: '',
        type: 'invoice_template'
      }
    }
  },
  methods: {
    create() {
      const vm = this
      // vm.document.value = `${vm.document.value}</page>`
      vm.$http
        .post('e-zacma/document/create', vm.document)
        .then(() => {
          vm.$success()
          vm.$router.push({ name: 'e-zacma-documents' })
        })
        .catch(() => {
          vm.$error()
        })
    },
    exit() {
      this.$router.push({ name: 'e-zacma-documents' })
    }
  },
  components: {
    Editor
  }
}
</script>

<style lang="scss">
.tox.tox-tinymce {
  min-height: 150mm !important;
}
.tox-sidebar-wrap {
  .tox-edit-area {
    background: #999999;
    .tox-edit-area__iframe {
      width: 210mm;
      padding: 11mm;
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: calc((100% - 210mm) / 2);
    }
  }
}
</style>
